module.exports = __webpack_public_path__ + "img/54.8e4da693.png";